var map = {
	"./wheel_2.png": "pDWz",
	"./wheel_3.png": "X6BG",
	"./wheel_4.png": "y0H3",
	"./wheel_5.png": "ErBR",
	"./wheel_6.png": "FpT3",
	"./wheel_boarder.png": "6CLv",
	"./wheel_boarder2.png": "KwyN",
	"./wheel_center.png": "jQbM",
	"./wheel_center2.png": "ySvr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3HCm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lotto ^\.\/wheel_.*\.png$
// module id = 3HCm
// module chunks = 2